import {
  Box,
  Button,
  ExpandMoreRoundedIcon,
  Flex,
  Menu,
  MenuItem,
  Rotate,
  Text,
} from '@shared/components';
import { useState } from 'react';

import {
  type QSetQuestionListOption,
  QSET_QUESTION_LIST_OPTIONS,
  useQSetQuestionListSearchParams,
} from '../../hooks';

export default function QSetQuestionDetailsNavigatorMenu() {
  const [{ pageSize }, { changePageSize }] = useQSetQuestionListSearchParams();

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const isExpanded = Boolean(anchorEl);

  const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickMenu = (newPageSize: QSetQuestionListOption) => {
    changePageSize(newPageSize);
    handleClose();
  };

  return (
    <Flex sx={{ gap: (theme) => theme.spacing(2), alignItems: 'center' }}>
      <Text variant='body2'>Result per page</Text>
      <Box>
        <Button
          variant='outlined'
          color='secondary'
          onClick={handleOpenMenu}
          sx={(theme) => ({
            minWidth: '70px',
            height: '34px',
            p: theme.spacing(1, 2),
            border: `1px solid ${theme.palette.grey[300]}`,
          })}
        >
          <Flex sx={{ width: '100%', gap: (theme) => theme.spacing(1), alignItems: 'center' }}>
            <Text sx={{ flexGrow: 1 }}>{pageSize}</Text>
            <Rotate in={isExpanded}>
              <ExpandMoreRoundedIcon sx={{ fontSize: '24px' }} />
            </Rotate>
          </Flex>
        </Button>
        <Menu open={isExpanded} anchorEl={anchorEl} onClose={handleClose}>
          {QSET_QUESTION_LIST_OPTIONS.map((option) => {
            return (
              <MenuItem
                key={`page-size-option-${option}`}
                selected={option === pageSize}
                onClick={() => {
                  handleClickMenu(option);
                }}
                sx={{
                  width: '52px',
                }}
              >
                {option}
              </MenuItem>
            );
          })}
        </Menu>
      </Box>
    </Flex>
  );
}
